<template>
  <div v-if="showing" class="gdpr__container">
    <p>Coletamos dados estatísticos de visitas para melhorar sua experiência de navegação e personalizar nossos conteúdos. Para mais informações sobre nossa política de utilização de cookies ou para alterar suas preferências, consulte nossa política de privacidade.</p>
    <div class="gdpr__action">
      <button class="ept-btn ept-btn--primary" @click="close">Aceitar</button>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    showing: true
  }),

  mounted() {
    if (localStorage.gdprShowing) {
      this.showing = Boolean(JSON.parse(localStorage.gdprShowing))
    }
  },

  watch: {
    showing(newValue) {
      localStorage.gdprShowing = newValue
    }
  },

  methods: {
    close() {
      this.showing = false
    }
  }
}
</script>

<style lang="scss" scoped>
.gdpr {
  &__container {
    @apply bg-white;
    @apply py-6;
    @apply px-8;
    @apply z-40;
    @apply inset-x-0;
    @apply bottom-0;
    @apply fixed;

    display: flex;
    flex-direction: column;

    border-radius: 4px 4px 0px 0px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

    @screen lg {
      flex-direction: row;
      align-items: center;

      border-radius: 0;
    }
  }

  &__action {
    @apply w-full;
    @apply mt-6;

    .ept-btn {
      @apply w-full;
    }

    @screen lg {
      @apply w-auto;
      @apply mt-0;
      @apply ml-8;

      .ept-btn {
        @apply w-auto;
      }
    }
  }
}
</style>
